import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import './CustomSectionStickyHeading.scss';


const CustomSectionStickyHeading = ({ children, className }) => (
  <div
    className={classNames(
      'custom-section__sticky-heading',
      className,
    )}
  >
    {children}
  </div>
);

CustomSectionStickyHeading.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

CustomSectionStickyHeading.defaultProps = {
  children: undefined,
  className: undefined,
};

export default CustomSectionStickyHeading;
